module.exports = __webpack_public_path__ + "img/logo.850291a5.png";